<template>
  <v-navigation-drawer v-if="showNavigation" v-model="model" color="navyblue">
    <v-list lines="two">
      <v-list-subheader inset color="white">
        Links
      </v-list-subheader>

      <v-list-item
        v-for="link of links"
        :key="link.title"
        :title="link.title"
        :subtitle="link.subtitle"
        :to="link.link"
        link
      >
        <template #prepend>
          <v-avatar color="primary">
            <v-icon color="white" :icon="link.icon" />
          </v-avatar>
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { computed, defineComponent, useModel } from 'vue'
import { useRoute } from 'vue-router'

import { RouteNames } from '@/router'

export default defineComponent({
  name: 'NavigationDrawer',

  emits: {
    // eslint-disable-next-line vue/no-unused-emit-declarations
    'update:modelValue': (_value: boolean) => true,
  },

  props: {
    modelValue: { type: Boolean, required: true },
  },

  setup (props) {
    const route = useRoute()
    const showNavigation = computed(() => route.name !== RouteNames.LOGIN)

    const links = [
      {
        title: 'Dashboard',
        subtitle: 'Main dashboard',
        link: { name: RouteNames.DASHBOARD },
        icon: 'mdi-graph',
      },
      {
        title: 'Import/Export',
        subtitle: 'Copy Policies between environments',
        link: { name: RouteNames.IMPORT_EXPORT },
        icon: 'mdi-folder-swap',
      },
      {
        title: 'Users',
        subtitle: 'List & manage users',
        link: { name: RouteNames.USER_LIST },
        icon: 'mdi-account-multiple',
      },
      {
        title: 'Groups',
        subtitle: 'List & manage groups',
        link: { name: RouteNames.GROUP_LIST },
        icon: 'mdi-account-group',
      },
      {
        title: 'Programs',
        subtitle: 'List & manage programs',
        link: { name: RouteNames.PROGRAM_LIST },
        icon: 'mdi-view-list',
      },
      {
        title: 'Tarballs',
        subtitle: 'List & manage pricing scenarios',
        link: { name: RouteNames.TARBALL_LIST },
        icon: 'mdi-briefcase',
      },
      {
        title: 'Attachments',
        subtitle: 'List & regenerate attachments',
        link: { name: RouteNames.ATTACHMENTS },
        icon: 'mdi-text-box-multiple',
      },
    ]

    const model = useModel(props, 'modelValue')

    return {
      showNavigation,
      links,
      model,
    }
  },
})
</script>
